import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6289bd00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-modal"
}
const _hoisted_2 = {
  key: 0,
  class: "text-grey-8 q-mb-lg",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_3 = {
  class: "flex",
  style: {"gap":".5rem"}
}
const _hoisted_4 = { style: {"flex-grow":"1"} }

import { useQuasar } from 'quasar';
import ToolBar from './ToolBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalConfirm',
  props: {
  show: Boolean,
  message: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    default: '',
  },
  confirm: {
    type: String,
    default: '',
  },
  cancelLabel: {
    type: String,
    default: 'Cancelar',
  },
  confirmLabel: {
    type: String,
    default: 'Continuar',
  },
},
  emits: ['confirm', 'cancel'],
  setup(__props) {




const q = useQuasar();

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_layout, {
          view: "Lhh lpR fff",
          container: "",
          class: "bg-custom custom-layout"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_header, { class: "bg-custom" }, {
              default: _withCtx(() => [
                _createVNode(ToolBar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      round: "",
                      color: _unref(q).dark.isActive ? 'purple-3' : 'purple-9',
                      flat: "",
                      icon: "close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancelar")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_page_container, { style: {"max-width":"460px","margin":"0 auto"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_page, {
                  padding: "",
                  class: "q-pt-lg"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(`text-h5 ${__props.description ? 'q-mb-xs' : 'q-mb-lg'}`)
                    }, _toDisplayString(__props.message), 3),
                    (__props.description)
                      ? (_openBlock(), _createElementBlock("pre", _hoisted_2, _toDisplayString(__props.description), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_btn, {
                        flat: "",
                        color: _unref(q).dark.isActive ? 'purple-2' : 'purple-9',
                        class: _normalizeClass(`${_unref(q).dark.isActive ? 'bg-dark' : 'bg-purple-1'} q-py-sm`),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.cancelLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["color", "class"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_btn, {
                          color: "purple-9 q-py-sm full-width",
                          unelevated: "",
                          disable: _ctx.submitting,
                          loading: _ctx.submitting,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.confirmLabel), 1)
                          ]),
                          _: 1
                        }, 8, ["disable", "loading"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})